import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon, type IconType } from '@factorialco/f0-react'
import {
  Bullet,
  Calendar,
  Check,
  GroupBy,
  Link,
  Numbers,
  Star,
  TextSize,
  Upload,
} from '@factorialco/f0-react/icons/app'
import type { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  children: React.ReactNode
  title: string
  description?: string
  questionType: FormsElementTypeEnum
}

export function ChartWidget({ children, title, description, questionType }: Props) {
  return (
    <Box
      width="full"
      border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
      borderRadius={{ all: 'abs016' }}
      padding="s16"
      gap="s24"
    >
      <Box gap="s8">
        <Text.Normal size="200" color="grey700">
          <Box gap="s4" flexDirection="row" alignItems="center">
            <F0Icon icon={getQuestionTypeData()[questionType].icon} />
            {getQuestionTypeData()[questionType].label}
          </Box>
        </Text.Normal>
        <Box gap="s4">
          <Text.Normal weight="semibold" color="grey1000">
            {title}
          </Text.Normal>
          <Text.Normal size="200" color="grey700">
            {description}
          </Text.Normal>
        </Box>
      </Box>
      <>{children}</>
    </Box>
  )
}

function getQuestionTypeData(): Record<FormsElementTypeEnum, { label: string; icon: IconType }> {
  return {
    select: {
      label: i18n.t('forms.modals.elements.single_choice'),
      icon: Bullet,
    },
    multiselect: {
      label: i18n.t('forms.modals.elements.multiple_choice'),
      icon: Check,
    },
    rating: {
      label: i18n.t('forms.modals.elements.rating'),
      icon: Star,
    },
    number: {
      label: i18n.t('forms.modals.elements.numeric'),
      icon: Numbers,
    },
    longtext: {
      label: i18n.t('forms.modals.elements.text'),
      icon: TextSize,
    },
    score: {
      label: i18n.t('forms.modals.elements.rating'),
      icon: Star,
    },
    text: {
      label: i18n.t('forms.modals.elements.text'),
      icon: TextSize,
    },
    url: {
      label: i18n.t('forms.modals.elements.url'),
      icon: Link,
    },
    date: {
      label: i18n.t('forms.modals.elements.date'),
      icon: Calendar,
    },
    section: {
      label: i18n.t('forms.modals.elements.section'),
      icon: GroupBy,
    },
    dropdownsingle: {
      label: i18n.t('forms.modals.elements.single_choice'),
      icon: Bullet,
    },
    file: {
      label: i18n.t('forms.modals.elements.file'),
      icon: Upload,
    },
  }
}
